var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24.7888,
    height: 24,
    rx: 12,
    fill: "#F74354"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3767 7.26676L17.233 5.12304C17.069 4.95899 16.803 4.95899 16.6387 5.12304L12.5 9.26217L8.3611 5.12326C8.19704 4.9592 7.93104 4.9592 7.76676 5.12326L5.62304 7.26698C5.45899 7.43104 5.45899 7.69704 5.62304 7.86131L9.76217 12L5.62326 16.1389C5.4592 16.303 5.4592 16.569 5.62326 16.7332L7.76698 18.877C7.93104 19.041 8.19704 19.041 8.36131 18.877L12.5 14.7378L16.6389 18.8767C16.803 19.0408 17.069 19.0408 17.2332 18.8767L19.377 16.733C19.541 16.569 19.541 16.303 19.377 16.1387L15.2378 12L19.3767 7.8611C19.541 7.69725 19.541 7.43104 19.3767 7.26676Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReject);
export default __webpack_public_path__ + "static/media/reject.fa22f893ad7a52331f198222be7df509.svg";
export { ForwardRef as ReactComponent };